import Controller from '@ember/controller';
import { action } from '@ember/object';
import { runTask } from 'ember-lifeline';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';
import textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';
import ImageUploader from 'quill2-image-uploader';
import ImageFormat from 'scaleflow/utils/quill-extenstions/image-format';
import imageResizeOptions from 'scaleflow/utils/quill-extenstions/image-resize';
import Quill from 'quill';
import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';
import imageUploadHandler from 'scaleflow/utils/quill-extenstions/image-uploader';
export const BON_INIT = {
  value: undefined,
  notes: '',
  investments: {
    value: 0,
    calculations: [],
  },
  returns: {
    value: 0,
    calculations: [],
  },
};

Quill.register('formats/image', ImageFormat, true);
registerIfNotRegistered(Quill, 'modules/imageUploader', ImageUploader);

export default class RoadmapTableInitiativeBackOfANapkinController extends Controller {
  @service betaToggle;
  @service store;
  @service initiativeSlideover;
  @service currentUser;
  @service session;
  @service organisation;
  @service intl;
  @tracked index = 0;
  @tracked editMode = false;

  @tracked showBonSlideover = false;
  @tracked showPpwSlideover = false;
  @tracked showInvestmentConfidenceSlideover = false;
  @tracked showReturnConfidenceSlideover = false;
  @tracked showUpsellValueSlideover = false;
  @tracked showFteSlideover = false;
  @tracked showClvSlideover = false;

  @tracked formHasErrors = false;

  queryParams = ['editMode'];

  @tracked bon = {
    value: undefined,
    notes: '',
    text_delta: {
      ops: [],
    },
    investments: {
      value: 0,
      calculations: [],
    },
    returns: {
      value: 0,
      calculations: [],
    },
  };

  get position() {
    return this.index + 1;
  }

  get bonValue() {
    return this.calculateBonValue(this.bon) ?? '-';
  }

  get formattedBon() {
    this.formatBon();
    return this.bon;
  }

  @action
  handleSubmit(e) {
    e.preventDefault();
  }

  get bodySelector() {
    return document.querySelector('body');
  }

  @action
  toggleEditMode() {
    this.editMode = !this.editMode;
    this.formatBon();
    if (this.editMode === true) {
      runTask(this, () => {
        document
          .querySelector('.bon-form')
          .scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  customTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.description === '' || !item.description) {
      hasErrors = true;
      document
        .getElementById(`${type}-custom-description-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-custom-description-${index}`)
        .classList.remove('input--error');
    if (item.value === '' || isNaN(+item.value)) {
      hasErrors = true;
      document
        .getElementById(`${type}-custom-value-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-custom-value-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  investmentTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.weeks === '' || isNaN(item.weeks)) {
      hasErrors = true;
      document
        .getElementById(`${type}-weeks-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-weeks-${index}`)
        .classList.remove('input--error');
    if (item.people === '' || isNaN(item.people)) {
      hasErrors = true;
      document
        .getElementById(`${type}-people-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-people-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  newCustomerTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.new_customers === '' || isNaN(item.new_customers)) {
      hasErrors = true;
      document
        .getElementById(`${type}-new-customers-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-new-customers-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  upsellTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.customers === '' || isNaN(item.customers)) {
      hasErrors = true;
      document
        .getElementById(`${type}-customers-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-customers-${index}`)
        .classList.remove('input--error');

    if (item.upsell_value === '' || isNaN(item.upsell_value)) {
      hasErrors = true;
      document
        .getElementById(`${type}-upsell-value-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-upsell-value-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  costFteTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.ftes === '' || isNaN(item.ftes)) {
      hasErrors = true;
      document
        .getElementById(`${type}-ftes-${index}`)
        .classList.add('input--error');
    }

    if (!hasErrors) {
      document
        .getElementById(`${type}-ftes-${index}`)
        .classList.remove('input--error');
    }

    return hasErrors;
  }

  @action
  bonHasIncompleteTemplates() {
    const investments = this.bon.investments?.calculations;
    const returns = this.bon.returns?.calculations;
    let formsHaveError = [];
    investments?.forEach((item, index) => {
      if (item.type === 'custom')
        formsHaveError.push(
          this.customTemplateValidator('Investment', item, index),
        );
      if (item.type === 'investment' || item.type === 'person-weeks-role')
        formsHaveError.push(
          this.investmentTemplateValidator('Investment', item, index),
        );
    });

    returns?.forEach((item, index) => {
      if (item.type === 'custom')
        formsHaveError.push(
          this.customTemplateValidator('Return', item, index),
        );
      if (item.type === 'new-customers')
        formsHaveError.push(
          this.newCustomerTemplateValidator('Return', item, index),
        );
      if (item.type === 'upsell')
        formsHaveError.push(
          this.upsellTemplateValidator('Return', item, index),
        );
      if (item.type === 'cost-fte')
        formsHaveError.push(
          this.costFteTemplateValidator('Return', item, index),
        );
    });
    return formsHaveError.includes(true);
  }

  @action
  handleSave(e) {
    e.preventDefault();
    if (this.bonHasIncompleteTemplates()) return;
    this.bon.initiative = this.model;
    this.bon.value = this.calculateBonValue(this.bon);
    this.bon.save().then(() => {
      this.toggleEditMode();
      this.model.reload();
    });
  }

  @action
  handleNotesChange(e) {
    this.bon.notes = e.target.value;
  }

  calculateBonValue(bon) {
    if (
      (isNullOrUndefined(bon?.returns) ||
        (bon.returns?.value === 0 &&
          bon.returns?.calculations?.length === 0)) &&
      (isNullOrUndefined(bon?.investments) ||
        (bon.investments?.value === 0 &&
          bon.investments?.calculations?.length === 0))
    )
      return undefined;
    else return (+bon.returns?.value || 0) - (+bon.investments?.value || 0);
  }

  @action
  updateBonInvestments(investments) {
    const bon = this.bon;
    if (bon.investments == undefined)
      bon.investments = { value: 0, calculations: [] };
    bon.investments.calculations = investments.calculations;
    bon.investments.value = investments.calculations.reduce((acc, curr) => {
      return acc + (curr?.value || 0) * (curr?.confidence_value || 0);
    }, 0);
    const bonValue = this.calculateBonValue(bon);

    bon.value = bonValue;
    this.bon = bon;
  }

  @action
  updateBonReturns(returns) {
    const bon = this.bon;
    if (bon.returns == undefined) bon.returns = { value: 0, calculations: [] };
    bon.returns.calculations = returns.calculations;
    bon.returns.value = returns.calculations.reduce((acc, curr) => {
      return acc + (curr?.value || 0) * (curr?.confidence_value || 0);
    }, 0);

    const bonValue = this.calculateBonValue(bon);
    bon.value = bonValue;
    this.bon = bon;
  }

  @action
  handleCancel() {
    if (!this.bon.id) {
      this.resetBon();
      this.toggleEditMode();
      return;
    }
    this.bon.rollbackAttributes();
    this.bon.reload().then(() => {
      this.bon.value = this.calculateBonValue(this.bon);
      this.toggleEditMode();
    });
  }

  @action
  toggleBonSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showBonSlideover = flag;
    else this.showBonSlideover = !this.showBonSlideover;
  }

  @action
  togglePpwSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showPpwSlideover = flag;
    else this.showPpwSlideover = !this.showPpwSlideover;
  }

  @action
  toggleInvestmentConfidenceSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showInvestmentConfidenceSlideover = flag;
    else
      this.showInvestmentConfidenceSlideover =
        !this.showInvestmentConfidenceSlideover;
  }

  @action
  toggleReturnConfidenceSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showReturnConfidenceSlideover = flag;
    else
      this.showReturnConfidenceSlideover = !this.showReturnConfidenceSlideover;
  }

  @action
  toggleUpsellValueSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showUpsellValueSlideover = flag;
    else this.showUpsellValueSlideover = !this.showUpsellValueSlideover;
  }

  @action
  toggleFteSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showFteSlideover = flag;
    else this.showFteSlideover = !this.showFteSlideover;
  }

  @action
  toggleClvSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showClvSlideover = flag;
    else this.showClvSlideover = !this.showClvSlideover;
  }

  @action
  formatBon() {
    const bon = this.bon;
    if (bon.investments?.calculations) {
      bon.investments?.calculations.forEach((item) => {
        if (item.type === 'custom') return;
        if (item.type === 'investment' || item.type === 'person-weeks-role') {
          const value = +item?.price_person_week * +item?.weeks * +item?.people;
          item.value = isNaN(value) ? null : value;
        }
      });
    }

    if (bon.returns?.calculations) {
      bon.returns?.calculations.forEach((item) => {
        if (item.type === 'custom') return;
        if (item.type === 'cost-fte') {
          const value =
            +item?.ftes * +item?.price_person_week * +item?.horizon * 4;
          item.value = isNaN(value) ? null : value;
        }
        if (item.type === 'new-customers') {
          const value = +item?.new_customers * +item?.bon_clv;
          item.value = isNaN(value) ? null : value;
        }
        if (item.type === 'upsell') {
          const value = +item?.customers * +item.upsell_value;
          item.value = isNaN(value) ? null : value;
        }
      });
    }
    if (
      bon?.text_delta &&
      bon?.text_delta?.ops &&
      bon?.text_delta?.ops?.length === 1 &&
      Object.keys(bon?.text_delta?.ops?.[0])?.length === 0
    ) {
      bon.text_delta = {
        ops: [],
      };
    }
  }

  @action
  resetBon() {
    const bon = this.bon;
    bon.initiative = this.model;
    bon.value = BON_INIT.value;
    bon.investments = {
      value: 0,
      calculations: [],
    };
    bon.returns = {
      value: 0,
      calculations: [],
    };
    bon.notes = BON_INIT.notes;
    this.bon = bon;
  }

  @action
  handleSettingsSlideoverOpen() {
    this.initiativeSlideover.open(this.model.id);
  }

  @action
  setDelta(e) {
    this.bon.text_delta = e;
  }

  get noSummaryOrDescription() {
    if (!this.model.description && textDeltaIsEmpty(this.model.summary))
      return true;
    return false;
  }

  get modules() {
    const modules = {};
    modules.imageUploader = {
      upload: (file) => {
        return imageUploadHandler(
          this.session.idToken,
          this.organisation.id,
          file,
        ).then((s3Link) => {
          return s3Link;
        });
      },
    };
    modules.resize = imageResizeOptions(this.intl);

    let toolbarOptions = [
      ['bold', 'italic', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ['link', 'image', 'clean'], // remove formatting button
    ];
    modules.toolbar = toolbarOptions;
    return modules;
  }
}
